export default __webpack_public_path__ + "static/media/wyndham5.71e711a6.png";